import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text } from 'rebass';
import { ErrorMessage, getIn } from 'formik';
import { TextFieldWrap, Label, ErrorMessageWrap } from '../text/styled';
import Grid from 'app/grid/index';

const SelectField = ({
  options,
  field,
  form: { setFieldValue, errors, touched },
  label,
  showError,
  ...props
}) => {
  const error = getIn(errors, field.name);
  const fieldtouched = getIn(touched, field.name);

  return (
    <TextFieldWrap {...props}>
      {label && <Label {...field}>{label}</Label>}
      <Grid gridTemplateColumns="repeat(auto-fill, minmax(40%, 40%))" gridGap={[1, 2]}>
        {options.map(option => {
          const isSelected = field.value === option.value
          return <Flex
            flexDirection="column"
            justifyContent="center" sx={{ border: `1.5px solid ${isSelected ? '#724086' : '#D1D1D1'}`, cursor: 'pointer', borderRadius: '23px' }}
            alignItems="center"
            bg={isSelected ? "#F5EEF8" : "white"}
            px={["20px"]}
            py={["10px"]}
            mb={[1, 0, 0]}
            height="max-content"
            mr="12px"
            onClick={() => {
              setFieldValue(field.name, option.value);
            }}
          >
            <Text fontFamily="Poppins" color={isSelected ? "#724086" : "mineShaft"} fontSize={[14, 16]} lineHeight={"24px"} letterSpacing={"-0.6px"}>{option.label}</Text>
          </Flex>
        })}
      </Grid>
      {error && fieldtouched && (
        <ErrorMessageWrap {...field} >
          {error}
        </ErrorMessageWrap>
      )}
    </TextFieldWrap>
  )
}

SelectField.propTypes = {
  field: PropTypes.shape({
  }).isRequired,
  options: PropTypes.arrayOf(PropTypes.shape).isRequired,
  form: PropTypes.shape({
  }).isRequired,
  placeholder: PropTypes.string,
};

SelectField.defaultProps = {
  placeholder: 'Select...',
};

export default SelectField;
